import { InjectionToken, Provider } from '@angular/core';
import { UserSettingsRepository } from '../user-settings.repository';
import { UserSettingsService } from '../user-settings.service';

export const HTTP_USER_SETTINGS_SERVICE = new InjectionToken<UserSettingsRepository>('HTTP_USER_SETTINGS_SERVICE');

export const USER_SETTINGS_API_PROVIDER: Provider = {
    provide: HTTP_USER_SETTINGS_SERVICE,
    useClass: UserSettingsService,
};
